const formatMultiselectErrors = (errorsObj) => {
  const formattedObj = {}
  for (const key in errorsObj) {
    if (errorsObj[key]) {
      const value = errorsObj[key]
      if (Array.isArray(value)) {
        formattedObj[key] = value.find(Boolean)
      } else {
        formattedObj[key] = value
      }
    }
  }
  return formattedObj
}
export default formatMultiselectErrors
